<template>
  <div class="pageFooter a-ipx-bottom-border">
    <img :src="imageMap.logo" alt="" class="logo">
  </div>
</template>

<script>
  import imageMap from '../../image-map.js';

  export default {
    data() {
      return { imageMap };
    }
  };
</script>

<style scoped lang="scss">
  @import "./page-footer.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/common/page-footer.vue